import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import Typography from "@mui/material/Typography";

const VehicleMatchCountColorMap = {
  success: "tertiaryGreen.main",
  warning: "primary",
  error: "secondary",
};

const VehicleMatchCount = ({
  currentCount,
  successThresholdCount,
  warningThresholdCount,
  isFetching,
  isLoading,
}: {
  currentCount: number;
  successThresholdCount: number;
  warningThresholdCount: number;
  isFetching: boolean;
  isLoading: boolean;
}) => {
  const countIsTooHigh = currentCount > successThresholdCount;
  let color;

  if (currentCount > warningThresholdCount || currentCount === 0) {
    color = VehicleMatchCountColorMap.error;
  } else if (currentCount > successThresholdCount) {
    color = VehicleMatchCountColorMap.warning;
  } else {
    color = VehicleMatchCountColorMap.success;
  }

  return (
    <Box>
      <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
        <Box>
          {isFetching || isLoading ? (
            <Box>
              <CircularProgress size={isLoading ? 24 : 16} color="primary" />
            </Box>
          ) : (
            <Typography variant="titleLarge" color={color}>
              {currentCount}
            </Typography>
          )}
        </Box>
        {!isLoading && (
          <Typography variant="titleLarge" color={color}>
            vehicles match
          </Typography>
        )}
      </Box>
      {countIsTooHigh && (
        <Typography variant="titleSmall" color={color}>
          Add criteria to narrow matches
        </Typography>
      )}
    </Box>
  );
};

export default VehicleMatchCount;
